import Controller from '@ember/controller';
import { A } from '@ember/array';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import { PAYOUT_ACCOUNT } from 'sh-www/models/payout-account';
import { PAYOUT_METHOD } from 'sh-www/models/payout-method';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';
import ENV from 'sh-www/config/environment';

class SettingsPayoutAddMethodController extends Controller {
  @service api;
  @service('error-tracker') errorTracker;
  @service('commands/hyperwallet-user-commands') hyperwalletUserCommands;
  @service('commands/payout-method-commands') payoutMethodCommands;
  @service router;
  @service session;
  @service shData;
  @service store;

  /** @type {Ember.A<PayoutMethod>} */
  @computed('model.payoutMethods.[]')
  get sortedPayoutMethods() {
    const payoutMethods = this.model.payoutMethods;

    if (!payoutMethods) return A([]);

    return payoutMethods.sort((a, b) => {
      const aClass = `${a.accountType}:${a.accountMethod}`;
      const bClass = `${b.accountType}:${b.accountMethod}`;

      if (aClass === bClass) return 0;

      return PAYOUT_METHOD.PAYOUT_METHOD_CLASSES.indexOf(aClass) - PAYOUT_METHOD.PAYOUT_METHOD_CLASSES.indexOf(bClass);
    });
  }

  @dropTask
  *loadCountries() {
    try {
      const response = yield this.api.request('/countries');

      this.shData.pushResponseToStore(response);
      const countries = this.shData.getModelArrayFromResponse(response, 'country');
      this.set('model.countries', countries);
    } catch (error) {
      handleErrorResponseWithModal(this, error);
      this.errorTracker.error(error, this);
    }
  }

  @dropTask
  *loadPayoutMethods() {
    try {
      const response = yield this.payoutMethodCommands.getAllPayoutMethods(this.session.currentUser);

      this.shData.pushResponseToStore(response);
      const payoutMethods = this.shData.getModelArrayFromResponse(response, 'payoutMethod');
      this.set('model.payoutMethods', payoutMethods);
    } catch (error) {
      handleErrorResponseWithModal(this, error);
      this.errorTracker.error(error, this);
    }
  }

  @dropTask
  *loadHyperwalletUser() {
    try {
      const response = yield this.hyperwalletUserCommands.getHyperwalletUser(this.session.currentUser.id);

      this.shData.pushResponseToStore(response);
      const hyperwalletUser = this.store.peekRecord('hyperwalletUser', response.data.id);
      this.set('model.hyperwalletUser', hyperwalletUser);
    } catch (error) {
      if (error.status === 404) return;

      handleErrorResponseWithModal(this, error);
      this.errorTracker.error(error, this);
    }
  }

  @action
  handleMethodSelect(payoutMethod, countryCode) {
    const payoutMethodId = payoutMethod.id;

    switch (payoutMethod.accountType) {
      case PAYOUT_ACCOUNT.ACCOUNT_TYPES.CUSTOM:
        window.location.href = `mailto:${ENV.supportEmail}}`;
        break;
      case PAYOUT_ACCOUNT.ACCOUNT_TYPES.HYPERWALLET:
        this.router.transitionTo('settings.payout.add-method.personal-info', {
          queryParams: { payoutMethodId, countryCode },
        });
        break;
      case PAYOUT_ACCOUNT.ACCOUNT_TYPES.PAYONEER:
        this.router.transitionTo('settings.payout.add-method.payoneer-setup', {
          queryParams: { payoutMethodId, countryCode },
        });
        break;
      default:
        break;
    }
  }
}

export default SettingsPayoutAddMethodController;
